export const typeMessage = {
  generic: {
    message: {
      es: 'Algo ha salido mal. Por favor vuelve a cargar la página.',
      en: 'Something went wrong! Please reload the page.'
    },
    firstMessage: {
      es: '¡Lo sentimos!',
      en: `We're sorry`
    }
  },
  permission: {
    message: {
      es:
        'Por favor asegúrate de que tienes un micrófono disponible para continuar. Ve a la configuración de tu dispositivo, elige tu navegador y acepta los permisos de la cámara y micrófono.',
      en:
        'Please make sure you have a microphone available to continue. Go to your device settings, choose your browser and accept the camera and microphone permissions.'
    },
    firstMessage: {
      es: 'El micrófono debe estar activado para continuar.',
      en: 'The microphone must be activated to continue.'
    }
  }
};

export const fullMessage = {
  es: 'La sentimos, la llamada a la que quiere ingresar esta llena.',
  en: `We're sorry, the meeting room you are trying to join is full.`
};

export const firstFullMessage = {
  es: 'Oops. hay demasiadas personas en la llamada.',
  en: 'Oops. There’s too many people on the call.'
};

export const firstRescheduleMessage = {
  es: 'Reagenda tu sesión.',
  en: 'Reschedule Meeting.'
};

export const meetingRoomFullMessage = {
  es:
    'Lo sentimos, la reunion a la que esta intentando ingresar esta llena. Si esta interesado en esta propiedad, deje su mail para ser contactado por el agente y agendar una cita.',
  en: `We're sorry, the meeting room you are trying to join is full. If you are interested in this property, just leave your mail below to be contacted by an agent to schedule a call.`
};

export const rescheduleMessage = {
  es:
    'Por favor, deja tus datos en el formulario para que un agente pueda contactarte y reagendar tu sesión.',
  en:
    'Please leave your mail below to be contacted by an agent to reschedule the meeting.'
};

export const buttonText = {
  es: 'Reintentar',
  en: 'Try Again'
};

export const buttonNextOnboarding = {
  es: 'Siguiente',
  en: 'Next'
};

export const buttonStartOnboarding = {
  es: 'Empezar',
  en: 'Start'
};

export const buttonSkip = {
  es: 'Saltar',
  en: 'Skip'
};

export const browserErrorMessage = {
  es: 'Lo Sentimos, esta aplicación no soporta este navegador.',
  en: 'Sorry, this browser does not support the application.'
};

export const browserErrorMessageSecond = {
  es: 'Por favor, inicie sesión en Safari.',
  en: 'Please, open this session in Safari.'
};

export const browserDesktopErrorMessageSecond = {
  es: 'Por favor abre tu sesión.',
  en: 'Please, open your session in.'
};

export const emailSentMessage = {
  es: 'Gracias!',
  en: 'Thank You!'
};

export const emailSentMessageSecond = {
  es: 'El agente se pondrá en contacto contigo.',
  en: 'The agent will get in touch with you.'
};

export const browserNotFoundErrorMessage = {
  es: 'No tienes ningún dispositivo de audio o video conectados.',
  en: 'You don’t have any audio or video devices connected.'
};

export const browserNotFoundErrorMessageSecond = {
  es: 'Por favor asegúrate de tener una cámara y micrófono conectado.',
  en: 'Please make sure you have a video camara and microphone to proceed.'
};

export const newSession = {
  es: 'Crear Nueva Sesión',
  en: 'Create New Session'
};

export const startSession = {
  es: 'Comenzar Sesión',
  en: 'Start Session'
};

export const nextSessions = {
  es: 'Próximas Sesiones',
  en: 'Upcoming Sessions'
};

export const nextSession = {
  es: 'Tu próxima sesión comenzará en',
  en: 'Your next session will start on'
};

export const withSession = {
  es: 'con',
  en: 'with'
};

export const activeSessionWith = {
  es: 'Tiene una sesión activa con',
  en: 'You have an active session with'
};

export const noSessionsRegistered = {
  es:
    'Aun no has creado ninguna sesión. Empieza dando click en Crear una nueva sesión',
  en: `You don't have any registered sessions. Get started by clicking on
  Create New Session`
};

export const sessionCreated = {
  es:
    '¡Tu sesión ha sido creada! Puedes compartir el link con tu cliente ahora, o ir al panel de Próximas Sesiones y hacer click en el botón de enlace para compartir más tarde.',
  en:
    'Your session has been created! Share the link to client now, or go to the Upcoming Sessions panel and click the link button to share later.'
};

export const goBackHome = {
  es: 'Ok, regresar al inicio',
  en: 'Ok, go back to Home'
};

export const backButton = {
  es: 'Regresar',
  en: 'Back'
};

export const deleteMeeting = {
  es: '¿Estas seguro de que deseas eliminar esta sesión?',
  en: 'Are you sure you want to delete this meeting?'
};

export const deleteButton = {
  es: 'Eliminar',
  en: 'Delete'
};

export const cancelButton = {
  es: 'Regresar',
  en: 'Cancel'
};

export const leaveSession = {
  es: '¿Estás seguro de que deseas abandonar esta sesión?',
  en: 'Are you sure you want to leave this session?'
};

export const noGoBack = {
  es: 'No, regresar',
  en: 'No, Go back'
};

export const yesFinish = {
  es: 'Si, terminar sesión',
  en: 'Yes, Finish Session'
};

export const yesChangeProperty = {
  es: 'Si, cambiar propiedad',
  en: 'Yes, Change Property'
};

export const sessionWillContinue = {
  es:
    'La sesión continuará hasta que el agente la termine. Para regresar, vuelve a utilizar el enlace de la sesión.',
  en:
    'The session will continue until the host finishes it. To come back enter the meeting link again.'
};

export const videoPreview = {
  es: 'Previo de Video',
  en: 'Video Preview'
};

export const device = {
  es: 'Dispositivo',
  en: 'Device'
};

export const joinWithoutVideo = {
  es: 'Entrar sin video',
  en: 'Join without video'
};

export const orJoinWithoutVideo = {
  es: 'O entra sin video',
  en: 'Or join without video'
};

export const joinWithVideo = {
  es: 'Entrar con video',
  en: 'Join with Video'
};

export const inputPlaceholder = {
  es: 'Búsqueda',
  en: 'Search'
};

export const settings = {
  es: 'Configuración',
  en: 'Settings'
};

export const logout = {
  es: 'Cerrar Sesión',
  en: 'Logout'
};

export const liveTourBroadcaster = {
  es:
    'Si estás en la propiedad que quieres mostrar, recorre el espacio con tu cámara para enseñarle al cliente los espacios.',
  en:
    'If you are in the property you want to showcase, go around the space with your camera to show the client the spaces.'
};

export const pickCamera = {
  es: 'Por favor escoge la cámara que quieres compartir:',
  en: 'Please pick the camera you want to share:'
};

export const startSharing = {
  es: 'Empieza a compartir la cámara',
  en: 'Start sharing camera'
};

export const liveTourLoader = {
  es: 'Tu agente esta empezando un Tour en Vivo.',
  en: 'Your agent is starting a Live Tour.'
};

export const noCategoriesSelected = {
  es: 'No hay categorías seleccionadas.',
  en: 'No categories selected.'
};

export const startByChoosing = {
  es: 'Empieza por elegir una categoría para ver lugares cercanos.',
  en: 'Start by choosing a category to see places nearby.'
};

export const atSession = {
  es: 'a las',
  en: 'at'
};

export const recentSessions = {
  es: 'Sesiones Recientes',
  en: 'Recent Sessions'
};

export const clientNameLabel = {
  es: 'Nombre',
  en: 'Name'
};

export const clientLastNameLabel = {
  es: 'Apellido',
  en: 'Last Name'
};

export const emailLabel = {
  es: 'Correo electrónico',
  en: 'Email'
};

export const phoneNumber = {
  es: 'Número telefónico (opcional)',
  en: 'Phone Number (Optional)'
};

export const date = {
  es: 'Fecha',
  en: 'Date'
};

export const time = {
  es: 'Hora',
  en: 'Time'
};

export const changePassword = {
  es: 'Cambiar Contraseña',
  en: 'Change Password'
};

export const currentPasswordLabel = {
  es: 'Contraseña Actual',
  en: 'Current Password'
};

export const newPasswordLabel = {
  es: 'Constraseña Nueva',
  en: 'New Password'
};

export const welcomeMessage = {
  es: 'Bienvenido',
  en: 'Welcome'
};

export const sessionReadyMessage = {
  es: 'Tu sesión esta lista',
  en: 'Your session is ready'
};

export const clickToGetStarted = {
  es: 'Empezar Sesión',
  en: 'Click to Get Started'
};

export const agentMessage = {
  es: 'Agente',
  en: 'Agent'
};

export const yourSessionWillStart = {
  es:
    'Tu sesión está por comenzar. Por favor, espera unos momentos mientras el anfitrión ingresa.',
  en:
    'Your session is about to start. Please wait for the host to get it started.'
};

export const sessionClosedMessage = {
  es: 'Tu sesión terminó.',
  en: 'Your session has ended'
};

export const yourSessionStartsOn = {
  es: 'Tu sesión va a comenzar el',
  en: 'Your session starts on'
};

export const yourSessionFor = {
  es: 'Tu sesión del',
  en: 'Your session for'
};

export const hasBeenCancelled = {
  es: 'fue cancelada.',
  en: 'has been cancelled'
};

export const pleaseContactAgent = {
  es: 'Por favor contacta a tu agente de ventas para más información:',
  en: 'Please contact your agent for information:'
};

export const switchProperties = {
  es: 'CAMBIO DE PROPIEDAD',
  en: 'SWITCH PROPERTIES'
};

export const property = {
  es: 'PROPIEDAD',
  en: 'PROPERTIES'
};

export const filterFloorplansBy = {
  es: 'Filtrar plantas por:',
  en: 'Filter Floorplans by:'
};

export const emailError = {
  es: 'Por favor ingresa una dirección de correo válida.',
  en: 'Please enter a valid email address.'
};

export const changeProperty = {
  es: '¿Estás seguro de que quieres cambiar de propiedad?',
  en: 'Are you sure you want to change the property?'
};

export const mightTakeAMinute = {
  es: 'Esto puede tomar un momento en cargar.',
  en: 'This might take a minute to load.'
};

export const sendToAgent = {
  es: 'Enviar al agente',
  en: 'Send to agent'
};

export const underLabel = {
  es: 'Menos de',
  en: 'Under'
};

export const overLabel = {
  es: 'Más de',
  en: 'Over'
};

export const floorAvailability = {
  es: 'Nivel / Disponibilidad',
  en: 'Floor / Availabilty'
};

export const bedsLabel = {
  es: 'Recámaras',
  en: 'Beds'
};

export const bathsLabel = {
  es: 'Baños',
  en: 'Baths'
};

export const unitLabel = {
  es: 'Unidad',
  en: 'Unit'
};

export const addAnotherUnitLabel = {
  es: 'Agrega otra unidad',
  en: 'Add another unit'
};

export const shareWithClientLabel = {
  es: 'Compartir',
  en: 'Share with client'
};

export const dateAvailable = {
  es: 'Fecha Disponile',
  en: 'Date Available'
};

export const phase = {
  es: 'Fase',
  en: 'Phase'
};

export const priceLabel = {
  es: 'Precio',
  en: 'Price'
};

export const allLabel = {
  es: 'Todos',
  en: 'All'
};

export const unitsLabel = {
  es: 'Unidades',
  en: 'Units'
};

export const discount = {
  es: 'Descuento',
  en: 'Discount'
};

export const discountPrice = {
  es: 'Precio con descuento',
  en: 'Discounted Price'
};

export const unitBudgetComparison = {
  es: 'Comparación de presupuestos',
  en: 'Unit Budget Comparison'
};

export const edit = {
  es: 'Editar',
  en: 'Edit'
};

export const waitingAgentCalculator = {
  es: 'Tu agente esta preparando tu presupuesto',
  en: 'Your agent is preparing your budget'
};

export const unitAdded = {
  es: 'Unidad agregada',
  en: 'Unit added'
};

export const pleaseSelect = {
  es: 'Por favor selecciona una unidad de la lista antes de agregar una nueva',
  en: 'Please select a unit from the dropdown before adding a new one'
};

export const areYouSure = {
  es: 'Estás seguro de que quieres eliminar esta unidad de la cotización?',
  en: 'Are you sure you want to remove this unit from the estimate?'
};

export const youWontBeAble = {
  es: 'Si la eliminas, no podrás recuperar los valores que editaste.',
  en: 'You won’t be able to recover the forms you edited.'
};

export const yesDelete = {
  es: 'Si, eliminar unidad',
  en: 'Yes, delete unit'
};
